<div class="container u-mt60">
  <div class="row">
    <div class="col-12">
      <div class="breadcrumbs">
        <ul>
          <li>
            <a routerLink="/dashboard">
              Inicio
            </a>
          </li>
          <li>
            <a routerLink="/task/task-list">
              Tareas
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-8">
      <h1 class="u-mb60 txt txt--title">
        Actualización antecedentes
      </h1>
    </div>
  </div>
</div>
<div class="bg--lightgrey u-pt50 u-pb70">
  <div class="container">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div class="u-center">
          <h2 class="u-mb30 txt txt--subtitle">
            Los cambios se han enviado correctamente
          </h2>
        </div>
      </div>

      <div class="col-md-10 offset-md-1">
        <div class="u-center">
          <app-flow-states [id]="+requestId" style="display: flex; justify-content: center;"></app-flow-states>
        </div>
      </div>
      <div class="col-md-8 offset-md-2">
        <div class="u-center">
          <div class="box box--white u-mb40 u-mt20">
            <div class="row">
              <div class="col-md-8 offset-md-2">
                <p class="txt u-mb0">
                  <!-- id  documento corregir se arrastra  en el actualizar  -->
                  <strong>
                    N° solicitud: {{requestId}}
                  </strong>
                </p>
                <p class="txt txt-paragraph u-mb0">
                  Una copia de su solicitud fue enviada al
                  correo electrónico {{storeUserData?.email}}
                </p>
              </div>
            </div>
          </div>
          <div>
            <div class="u-mb30 u-mt5">
              <p class="txt txt--paragraph">
                Puedes ver el detalle de la solicitud a través del siguiente link
              </p>
            </div>
          </div>
          <div class="">
            <button type="button" class="btn btn--primary" (click)="goToRequestDetail()">Ver
              detalle
              solicitud</button>
          </div>
          <div class="u-mb50 u-mt5">
            <a class="btn btn--link btn--link--secondary" routerLink="/license/new">Crear una nueva
              solicitud</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
